import Vue from 'vue';

export class GraphService {
  private graphUrl: string;

      constructor() {
        this.graphUrl = 'https://graph.microsoft.com/v1.0/';
    }

    public getUserInfo(token) {
        const headers = new Headers({ Authorization: `Bearer ${token}` });
        const options = {
            headers
        };
        return fetch(`${this.graphUrl}/me`, options)
            .then(response => response.json())
            .catch(response => {
                throw new Error(response.text());
            });
    }
}

const graphService = new GraphService();

Vue.use({
  install(vue) {
    vue.prototype.$graphService = graphService;
  }
});
